import { render, staticRenderFns } from "./DBIcon.vue?vue&type=template&id=6673c00a&"
import script from "./DBIcon.vue?vue&type=script&lang=js&"
export * from "./DBIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports